import { RouteConfig } from "vue-router";
import { UserState } from "@/store/modules/auth/interfaces";
import { candidate_interview_routes } from "@/router/sub_routes/candidates/candidate_interview_routes";
import { candidate_assessment_routes } from "@/router/sub_routes/candidates/candidate_assessment_routes";

export const candidates_routes: RouteConfig = {
  path: "/candidate",
  component: () => import("@/views/candidate/CandidateWrapper.vue"),
  meta: {
    user_state: [UserState.CANDIDATE]
  },
  children: [
    {
      path: "",
      redirect: {
        name: "candidate-dashboard"
      }
    },
    {
      path: "dashboard",
      name: "candidate-dashboard",
      component: () => import("@/views/candidate/CandidateDashboard.vue"),
      meta: {
        name: "nav-sidebar.dashboard",
        icon: require("@/assets/icons/nav_sidebar/active/dashboard.svg"),
        user_state: [UserState.CANDIDATE]
      }
    },
    {
      path: "jobs",
      component: () => import("@/views/candidate/CandidateJobsWrapper.vue"),
      meta: {
        user_state: [UserState.CANDIDATE]
      },
      children: [
        {
          path: "",
          name: "candidate-jobs",
          component: () => import("@/views/candidate/CandidateJobs.vue"),
          meta: {
            name: "nav-sidebar.matching-job",
            icon: require("@/assets/icons/nav_sidebar/active/jobs.svg"),
            user_state: [UserState.CANDIDATE]
          }
        },
        {
          path: "view/:id",
          name: "candidate-matching-job",
          component: () => import("@/views/candidate/ViewMatchingJob.vue"),
          meta: {
            name: "nav-sidebar.job",
            icon: require("@/assets/icons/nav_sidebar/active/jobs.svg"),
            user_state: [UserState.CANDIDATE]
          }
        },
        {
          path: "upskill-career",
          name: "candidate-upskill-career",
          component: () => import("@/views/candidate/UpskillCareer.vue"),
          meta: {
            name: "nav-sidebar.upskill-career",
            icon: require("@/assets/icons/nav_sidebar/active/jobs.svg"),
            user_state: [UserState.CANDIDATE]
          }
        }
      ]
    },
    candidate_interview_routes,
    {
      path: "courses",
      name: "candidate-courses",
      component: () => import("@/views/candidate/CandidateCourses.vue"),
      meta: {
        name: "nav-sidebar.courses",
        icon: require("@/assets/icons/nav_sidebar/active/courses.svg"),
        user_state: [UserState.CANDIDATE]
      }
    },
    {
      path: "linkedin-auto-apply",
      name: "candidate-linkedin-auto-apply",
      component: () => import("@/views/candidate/LinkedInAutoApply.vue"),
      meta: {
        name: "nav-sidebar.linkedin-auto-apply",
        icon: require("@/assets/icons/nav_sidebar/active/jobs.svg"),
        user_state: [UserState.CANDIDATE]
      }
    },
    {
      path: "profile",
      name: "personal-profile",
      component: () => import("@/views/candidate/ViewProfile.vue"),
      meta: {
        name: "nav-sidebar.profile",
        icon: require("@/assets/icons/nav_sidebar/active/candidates.svg"),
        user_state: [UserState.CANDIDATE]
      }
    },
    {
      path: "profile-loading",
      name: "profile-fetching",
      component: () => import("@/views/candidate/ProfileLoading.vue"),
      meta: {
        name: "nav-sidebar.fetching",
        icon: require("@/assets/icons/nav_sidebar/active/teacher.svg"),
        user_state: [UserState.CANDIDATE_PROFILE_PENDING]
      }
    },
    {
      path: "linkedin-auto-apply",
      name: "candidate-linkedin-auto-apply",
      component: () => import("@/views/candidate/LinkedInAutoApply.vue"),
      meta: {
        name: "nav-sidebar.linkedin-auto-apply",
        icon: require("@/assets/icons/linkedin.svg"),
        user_state: [UserState.CANDIDATE]
      }
    },
    {
      path: "error",
      name: "candidate-error",
      component: () => import("@/views/ErrorPage.vue"),
      meta: {
        name: "nav-sidebar.error",
        icon: require("@/assets/icons/nav_sidebar/active/settings.svg"),
        user_state: [UserState.CANDIDATE]
      }
    },
    {
      path: "*",
      component: () => import("../views/NotFound.vue"),
      meta: {
        name: "nav-sidebar.not-found",
        icon: require("@/assets/icons/nav_sidebar/active/settings.svg"),
        user_state: [
          UserState.UNAUTHENTICATED,
          UserState.EMAIL_VERIFICATION_PENDING,
          UserState.EMAIL_VERIFICATION_COMPLETED,
          UserState.ONBOARDING_PENDING,
          UserState.RECRUITER,
          UserState.RECRUITER_ADMIN,
          UserState.CANDIDATE
        ]
      }
    }
  ]
};
